export default "__VITE_PUBLIC_ASSET__04ff3d68__"